import { render, staticRenderFns } from "./StaggerEntranceTransitionGroup.vue?vue&type=template&id=532b7674&"
import script from "./StaggerEntranceTransitionGroup.vue?vue&type=script&lang=js&"
export * from "./StaggerEntranceTransitionGroup.vue?vue&type=script&lang=js&"
import style0 from "./StaggerEntranceTransitionGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports